<template>
  <div class="page_logReimbursement">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="申请公司" size="small">
              <el-select v-model="listQuery.companyName" placeholder="" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="报销人" size="small">
              <el-select v-model="listQuery.applyUserNameId" placeholder="" clearable size="small" style="width: 180px;" filterable>
                <el-option v-for="(item,index) in customerList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务项目" size="small">
              <el-select v-model="listQuery.projectName" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
          <el-form-item label="报销单编号">
            <el-input v-model="listQuery.advanceNum" size="small" style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="提交时间:">
            <div class="flex aic">
              <el-date-picker v-model="listQuery.applyTimeStart" type="date" value-format="yyyy-MM-dd" placeholder="" style="width: 180px;" size="small"></el-date-picker>
              <div style="margin: 0 10px;"> ~ </div>
              <el-date-picker v-model="listQuery.applyTimeEnd" type="date" value-format="yyyy-MM-dd" placeholder="" style="width: 180px;" size="small"></el-date-picker>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>日志报销</el-breadcrumb-item>
          <el-breadcrumb-item>{{tabName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="工作日志" name="0"></el-tab-pane>
          <el-tab-pane label="报销单" name="1"></el-tab-pane>
          <el-tab-pane label="部门审核" name="2"></el-tab-pane>
          <el-tab-pane label="财务审核" name="3"></el-tab-pane>
          <el-tab-pane label="待打款" name="6"></el-tab-pane>
          <!-- <el-tab-pane label="部分打款" name="9"></el-tab-pane> -->
          <el-tab-pane label="打款中" name="A"></el-tab-pane>
          <el-tab-pane label="已打款" name="7"></el-tab-pane>
          <el-tab-pane label="打款失败" name="8"></el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex">
          <el-button type="danger" size="small" @click="addReimbursement" v-if="checkPermission(['worklog_fillInRei'], permissionLists) && activeName=='1'">填写报销单</el-button>
          <!-- <el-button type="primary" size="small" v-if="activeName=='1'">批量导入报销单</el-button> -->
          <el-button type="success" size="small" @click="bacthPay" v-if="(activeName=='6' || activeName=='8')&& checkPermission(['worklog_finApprove_payment'], permissionLists)">{{ activeName=='6' ? '批量打款' : '批量重新打款' }}</el-button>
          <el-button type="warning" size="small" @click="confirmbacthPayHand('1')" v-if="(activeName=='6' || activeName=='8' || activeName=='A')&& checkPermission(['worklog_finApprove_payment'], permissionLists)">{{ activeName=='6' ? '批量手工打款成功' : '批量手工打款成功' }}</el-button>
          <el-button type="warning" size="small" @click="confirmbacthPayHand('0')" v-if="(activeName=='6' || activeName=='A') && checkPermission(['worklog_finApprove_payment'], permissionLists)">{{ activeName=='6' ? '批量手工打款失败' : '批量手工打款失败' }}</el-button>
          <el-button type="success" size="small" @click="bacthApprove" v-if="activeName=='3' && checkPermission(['worklog_finApprove'], permissionLists)">批量审批</el-button>
          <el-button type="warning" size="small" @click="batchPrint2" v-if="(activeName=='3' || activeName=='7') && checkPermission(['worklog_finApprove'], permissionLists)">批量打印</el-button>
          <el-button type="primary" size="small" @click="exportList">导出</el-button>

          <div class="payTips">报销时间为每月28号至次月6号，每月仅能提交一次。九月报销时间为20号至次月11号。</div>
        </div>
        <el-table :data="tableData" border class="doc_table" @expand-change="handleExpandChange" v-loading="loading" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange" ref="logTable" style="width:100%">
          <el-table-column key="sele" type="selection" width="40">
          </el-table-column>
          <el-table-column key="expand" type="expand" v-if="activeName=='1' || activeName=='2' || activeName=='3'">
            <template slot-scope="props">
              <div class="expandTable">
                <el-table :data="expandTable" class="doc_table" v-loading="loading">
                  <el-table-column prop="advanceNum" label="日志编号" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="applyTime" label="发生时间" width="160" :show-overflow-tooltip="true" align="center">
                    <template slot-scope={row}>{{row.applyTime ? row.applyTime.replace('T',' ') : ''}}</template>
                  </el-table-column>
                  <el-table-column prop="totalFees" label="费用金额" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="descFees" label="事由描述" width="200" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="附件" width="100" :show-overflow-tooltip="true" align="center">
                    <template slot-scope={row}>
                      <span @click="toDownFile(row.fileUrl)" class="blueName cp">{{row.fileName && row.fileUrl ? row.fileName : ''}}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <!-- <div class="block" style="max-width:1000px">
                  <el-pagination v-if="expandTotal>0" @current-change="currentChangeExpand" :current-page.sync="expandQuery.pageNum" :page-size="Number(expandQuery.pageSize)" @size-change="handleSizeChangeExpand" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="expandTotal"></el-pagination>
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column key="3" prop="busNum" label="申请号" min-width="125" :show-overflow-tooltip="true" align="center" v-if="activeName=='A'">
          </el-table-column>
          <el-table-column key="4" prop="advanceNum" label="报销单编号" min-width="165" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column key="5" prop="reimbTime1" label="发生月份" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="occurrenceMonth" label="发生月份" min-width="100" :show-overflow-tooltip="true" align="center" v-if="tabName=='待打款'">
          </el-table-column> -->
          <el-table-column key="6" prop="writtenAmount" label="申请金额" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- 凭证类型：取 ReimbContent 里的 voucherType（仅财务核销 tab 显示） -->
          <el-table-column key="7" prop="voucherType" label="凭证类型" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='3'">
            <template slot-scope={row}>
              <span class="flex aic" style="justify-content:center;cursor:default">
                <span>{{ row.voucherType || '-' }}</span>
                <el-tooltip v-if="row.hasRisk" content="有风险" placement="top" :open-delay="200">
                  <i class="el-icon-warning" style="color:red;font-size:16px;margin-left:4px"></i>
                </el-tooltip>
              </span>
            </template>
          </el-table-column>
          <el-table-column key="8" prop="name" label="打款金额" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='7' || activeName=='8'">
          </el-table-column>
          <el-table-column key="9" prop="name" label="打款方式" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='7' || activeName=='8'">
          </el-table-column>
          <el-table-column key="10" prop="name" label="打款时间" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='7' || activeName=='8'">
          </el-table-column>
          <el-table-column key="12" prop="companyName" label="打款公司" min-width="240" :show-overflow-tooltip="true" align="center" v-if="activeName=='2' ||activeName=='3' ||activeName=='6' ||activeName=='7' || activeName=='8'">
          </el-table-column>
          <el-table-column key="13" prop="writtenName" label="报销人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="writtenAuditor" label="报销人" min-width="100" :show-overflow-tooltip="true" align="center" v-if="tabName=='待打款'">
          </el-table-column> -->
          <el-table-column key="14" prop="depName" label="报销人部门" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="writtenDep" label="报销人部门" min-width="100" :show-overflow-tooltip="true" align="center" v-if="tabName=='打款失败' || tabName=='待打款'">
          </el-table-column> -->
          <el-table-column key="15" prop="processStateStr" label="状态" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='1' || activeName=='2' || activeName=='3'">
            <!-- <template slot-scope={row}>{{ row.processState=='1' ? '草稿' : row.processState=='2' || row.processState=='3' ? '待审核' : ''}}</template> -->
          </el-table-column>
          <el-table-column key="16" prop="financialAudit" label="审批人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column key="17" prop="updataTime" :label="activeName=='报销单' ? '提交时间' : '提交日期'" min-width="140" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{row.updataTime ? moment(row.updataTime).format('YYYY-MM-DD') : ''}}</template>
          </el-table-column>
          <el-table-column key="18" prop="updataTime" label="更新时间" min-width="160" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.updataTime ? row.updataTime.replace('T',' ') : ''}}</template>
          </el-table-column>
          <el-table-column label="操作" :min-width="activeName=='3' ? '220px' : '180px'" align="center" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="toDtl(row,'dtl')">{{activeName=='3' ? '明细（打印/下载）' : '查看'}}</el-button>
                <el-button type="text" @click="toDtl(row,'edit')" v-if="activeName=='1' && (row.processState == '1' || row.processState == '5')">编辑</el-button>
                <el-button type="text" @click="SubmitWriteoff(row)" v-if="activeName=='1' && (row.processState == '1' || row.processState == '5')">提交</el-button>
                <el-button type="text" v-if="(activeName=='2' && checkPermission(['worklog_depApprove'], permissionLists))|| (activeName=='3' && checkPermission(['worklog_finApprove'], permissionLists))" @click="toDtl(row,'approve')">审核</el-button>
                <el-popconfirm title="请确认是否作废？" @confirm="del(row)" style="margin: 0 10px;" v-if="activeName=='1' && checkPermission(['worklog_del'], permissionLists) && (row.processState == '1' || row.processState == '5')">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>
                <!-- <el-popconfirm title="请确认是否撤销？" @confirm="revoke(row)" style="margin: 0 10px;" v-if="(activeName=='2' && checkPermission(['worklog_depApprove_revoke'], permissionLists))|| ((activeName=='3' || activeName=='6') && checkPermission(['worklog_finApprove_revoke'], permissionLists))">
                  <el-button type="text" slot="reference">撤销</el-button>
                </el-popconfirm> -->
                <el-popconfirm title="请确认是否撤销？" @confirm="revoke(row)" style="margin: 0 10px;" v-if="activeName=='2'|| activeName=='3' || activeName=='6' || activeName=='A'">
                  <el-button type="text" slot="reference">撤销</el-button>
                </el-popconfirm>
                <el-button type="text" v-if="(activeName=='6' || activeName=='A') && checkPermission (['worklog_finApprove_payment'], permissionLists)" @click="toPayment(row)">打款</el-button>
                <el-button type="text" v-if="activeName=='8' && checkPermission(['worklog_finApprove_payment'], permissionLists)" @click="toPayment(row)">重新打款</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="批量打款" :visible.sync="showBatchPay" width="800px">
      <el-table :data="multipleSelection" class="doc_table">
        <el-table-column prop="advanceNum" label="报销单编号" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="reimbTime1" label="发生月份" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="writtenAmount" label="申请金额" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="companyName" label="打款公司" min-width="240" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="writtenName" label="报销人" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <!-- <el-table-column label="操作" width="160" align="center">
          <template slot-scope={row}>
            <div class="injuryTabBtn">
              <el-button type="text" slot="reference">作废</el-button>
            </div>
          </template>
        </el-table-column> -->
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBatchPay = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmBatchPay" :loading="isBtnLoading">选择打款账号</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="payResult=='1'?'批量手工打款成功': '批量手工打款失败'" :visible.sync="showBatchhandc" width="800px">
      <el-table :data="multipleSelection" class="doc_table">
        <el-table-column prop="advanceNum" label="报销单编号" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="reimbTime1" label="发生月份" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="writtenAmount" label="申请金额" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="companyName" label="打款公司" min-width="240" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="writtenName" label="报销人" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <!-- <el-table-column label="操作" width="160" align="center">
          <template slot-scope={row}>
            <div class="injuryTabBtn">
              <el-button type="text" slot="reference">作废</el-button>
            </div>
          </template>
        </el-table-column> -->
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBatchhandc = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="bacthPayHand(type)" :loading="isBtnLoading">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog width="700px" title="选择打款账号" :visible.sync="innerVisibleCA">
      <div v-if="innerVisibleCA">
        <div class="salaryPayingCompanyBox" v-if="BankAccount.length > 0">
          <div class="salaryPayingCompany">打款公司：{{ multipleSelection[0].companyName }}</div>
          <div class="salaryPayingCompany_radio">
            <el-radio :label="bank.Account" v-for="bank in BankAccount" :key="bank.Account" style="margin-bottom: 10px;" v-model="payForm.payAccount">开户行：{{ bank.OpeningBank }} 帐号：{{
          bank.Account
        }}</el-radio>
          </div>
        </div>
      </div>
      <div v-else class="noAccountTips">暂未配置打款公司CBS银行账户</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisibleCA = false" size="small">取 消</el-button>
        <el-button type="warning" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" @click="innerPay">内部转账</el-button>
        <el-button type="primary" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" @click="confirmPay">确认打款</el-button>
      </span>
    </el-dialog>

    <el-dialog width="700px" title="提交内部转款" :visible.sync="innerVisibleIC">
      <div v-if="innerVisibleIC">
        <div class="salaryPayingCompanyBox">
          <div class="salaryPayingCompany">付款方：
            <el-select v-model="internalCompany" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changeIC">
              <el-option v-for="(item, index) in legList" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </div>
          <div class="salaryPayingCompany_radio" v-if="icBankAccount.length > 0">
            <el-radio :label="bank.Account" v-for="bank in icBankAccount" :key="bank.Account" style="margin-bottom: 10px;" v-model="InternalAccount">开户行：{{ bank.OpeningBank }} 帐号：{{
          bank.Account
        }}</el-radio>
          </div>
        </div>
        <div v-if="icBankAccount.length == 0" class="noAccountTips">暂未配置{{internalCompany}}CBS银行账户</div>

        <div class="salaryPayingCompany flex sb">
          <div>收款方：{{ multipleSelection[0].companyName }}</div>
          <div style="margin-right:50px">金额：￥{{ TotalFees }}</div>
        </div>
        <div>
          账户：{{ payForm.payAccount }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisibleIC = false" size="small">取 消</el-button>
        <el-button type="primary" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" @click="confirmICPay">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批量审批" :visible.sync="showBatchApprove" width="800px">
      <el-table :data="multipleSelection" class="doc_table">
        <el-table-column prop="advanceNum" label="报销单编号" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="reimbTime1" label="发生月份" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="writtenAmount" label="申请金额" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="companyName" label="打款公司" min-width="240" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="writtenName" label="报销人" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBatchApprove = false" size="small">取 消</el-button>
        <!-- <el-button type="danger" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="confirmBatchApprove('0')">退 回</el-button> -->
        <el-button type="success" v-preventReClick style="margin-left:10px;" size="small" @click="confirmBatchApprove('1')" :loading="isBtnLoading">确认通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment';
  import * as math from 'mathjs'
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "updataTime",
              order: 1
            }]
          },
          processState: '1', //1编辑 2 部门审核 3财务审核 4核销完成 5核销被退回 6待打款 7已打款 8打款失败
          applyMonth: '',
          companyName: '',
          advanceNum: '',
          applyUserNameId: '',
          writtenName: '', //核销提交人
          hasReimbContentName: '',
          applyTimeStart: '',
          applyTimeEnd: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        showDropScreen: -1,
        activeName: '1',
        payResult: '',
        num1: 0,
        tableData: [],
        expandTable: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        proNameList: [], //项目列表
        multipleSelection: [],
        legList: [],
        permissionLists: [],
        showBatchPay: false,
        showBatchhandc: false,
        customerList: [], //客服列表
        tabName: '报销单',
        payForm: {
          id: '',
          BusiType: 2,
          payAccount: '', //公司的付款账号
          payAccountName: '', //公司的付款账号
          payAccountDepositBank: '', //公司的付款账号开户行
          InternalAccount: '', //内部账号
          InternalAccountName: '', //内部账号名
        },
        innerVisibleCA: false,
        innerVisibleIC: false,
        internalCompany: '宁波英普瑞特供应链管理有限公司', //内部转账公司
        InternalAccount: '',
        TotalFees: 0,
        BankAccount: [], //银行列表
        icBankAccount: [],
        isBtnLoading: false,
        showBatchApprove: false,
        needLoading: false,
        setForm: {
          date: '',
          time: '',
          aaa: '',
        }
      }
    },
    created() {
      if (localStorage.roleName.indexOf('财务') == -1 && localStorage.roleName.indexOf('管理员') == -1) {
        this.listQuery.applyUserNameId = Cookies.get("userid-b");
      }
      if (this.$route.query.activeName != undefined && this.$route.query.activeName) {
        this.tabName = this.$route.query.tabName;
        this.activeName = this.$route.query.activeName;
        this.changeTab('');
      } else {
        this.getList();
      }
      this.getProList();
      this.getlegalsubjectlist();
      this.getButtonPower();
      this.getMemberList();
    },
    mounted() {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && this.needLoading) {
          // console.log('visible')
          // 可见时，重新查询。
          // 请求表格数据方法
          this.getList();
          this.needLoading = false;
        } else {
          // console.log('hidden')
        }
      })
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/workLog',
          powerEnName: 'workLog'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      // 获取人员列表
      getMemberList() {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        }
        xz.getauthUserInfoByorgancode(data).then((res) => {
          if (res.status == "ok") {
            this.customerList = res.msg;
          } else {
            this.customerList = [];
          }
        });
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let d = {
          userid: Cookies.get("userid-b"),
          companyName: '',
          isCanInsure: false,
          pageNum: 1,
          pageSize: 1000
        }
        xz.ArdCurStat(d, 'GetUserLegalList').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.date;
          } else {
            this.legList = [];
          }
        })

      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        // let pagename = this.tabName == '财务审核' || this.tabName == '待打款' || this.tabName == '打款失败' ? 'GetAdvLogWritFinanPageList' : 'GetLogVerifPageList'
        let pagename = 'GetLogVerifPageList';
        if (this.activeName == '1') {
          this.listQuery.processState = ''
        }
        xz.AdvanceFun(this.listQuery, pagename).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.tableData.forEach(element => {
              if (element.depName) {
                let arr = element.depName.split(',');
                this.$set(element, 'dep', arr[arr.length - 1])
              }
            });
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab(tab) {
        if (this.activeName == '0') {
          this.$router.push('/worklog')
        } else {
          if (tab != '') {
            this.tabName = tab.$options.propsData.label;
          }
          this.listQuery.processState = this.activeName;
          this.getList()
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //展开表格
      handleExpandChange(row, rows) {
        if (rows.length > 1) {
          this.expandTable = []
          this.$refs.logTable.toggleRowExpansion(rows[0]);
        }
        if (this.tabName == '财务审核' || this.tabName == '待打款') {
          let d = {
            busiId: row.advanceId,
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype
          }
          xz.GetWriteoffDetail(d).then(r => {
            if (r.status == 'ok' && r.data.advanceIds) {
              let data = {
                ids: r.data.advanceIds,
                userId: Cookies.get("userid-b"),
                roleType: localStorage.loginRoletype,
              }
              xz.AdvanceFun(data, 'GetAdvancesListById').then(res => {
                if (res.status == 'ok') {
                  this.expandTable = res.data;
                } else {
                  this.expandTable = [];
                }
              })
            } else {
              this.expandTable = [];
            }
          })
        } else {
          let data = {
            ids: row.advanceIds,
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
          xz.AdvanceFun(data, 'GetAdvancesListById').then(res => {
            if (res.status == 'ok') {
              this.expandTable = res.data;
            } else {
              this.expandTable = [];
            }
          })
        }
      },
      //填写报销单
      addReimbursement() {
        // this.$router.push({
        //   path: '/logReiDtl',
        //   query: {
        //     type: 'add',
        //     activeName: this.activeName,
        //     tabName: this.tabName
        //   }
        // })
        this.needLoading = true;
        let now = moment().format('YYYY-MM-DD');
        // if (moment(now).date() > 27 || moment(now).date() < 7) {
        const routerUrl = this.$router.resolve({
          path: "/logReiDtl",
          query: {
            type: 'add',
            activeName: this.activeName,
            tabName: this.tabName
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
        // } else {
        //   this.$message.warning('当前时间不是提交日志报销时间，请每月28日~次月6日提交')
        // }

      },
      //批量打印：只打开一个页签，把勾选的多张报销单按顺序合并到同一页面，只弹一次打印对话框
      batchPrint2() {
        if (!this.multipleSelection || this.multipleSelection.length == 0) {
          this.$message.warning('请先勾选需要打印的报销单！');
          return;
        }
        if (this.multipleSelection.length > 20) {
          this.$message.warning('最多只能批量打印20张报销单！');
          return;
        }
        const routerUrl = this.$router.resolve({
          path: "/logReiDtl",
          query: {
            type: 'batchPrint',
            writeOffIds: this.multipleSelection.map(row => row.id).join(','),
            activeName: this.activeName,
            tabName: this.tabName,
            autoPrint: 1
          }
        });
        window.open(routerUrl.href, "_blank");
      },
      toDtl(row, type) {
        this.needLoading = true;
        if (this.tabName == '财务审核' || this.tabName == '待打款') {
          const routerUrl = this.$router.resolve({
            path: "/logReiDtl",
            query: {
              type,
              id: row.id,
              advanceId: row.advanceId,
              activeName: this.activeName,
              tabName: this.tabName,
              companyName: row.companyName
            }
          });
          const newWindow = window.open(routerUrl.href, "_blank");
        } else {
          const routerUrl = this.$router.resolve({
            path: "/logReiDtl",
            query: {
              type,
              id: row.id,
              activeName: this.activeName,
              tabName: this.tabName
            }
          });
          const newWindow = window.open(routerUrl.href, "_blank");
        }

      },
      SubmitWriteoff(row) {
        if (!this.loading) {
          this.loading = true;
          let data = {
            id: row.id,
            type: '2', //1.为暂支，2为日志
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype
          }
          xz.SubmitWriteoff(data).then(res => {
            if (res.status == 'ok') {
              this.loading = false;
              this.$message.success('保存成功');
              this.getList();
            } else {
              this.$message.error(res.msg);
              this.loading = false;
              this.getList();
            }
          })
        }
      },
      //去打款
      toPayment(row) {
        // this.$router.push({
        //   path: '/logPayment',
        //   query: {
        //     advanceId: row.advanceId,
        //     companyName: row.companyName,
        //     id: row.id
        //   }
        // })
        this.needLoading = true;
        const routerUrl = this.$router.resolve({
          path: "/logPayment",
          query: {
            advanceId: row.advanceId,
            companyName: row.companyName,
            id: row.id
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      toDownFile(url) {
        window.open(url, "_blank");
      },
      del(row) {
        if (!this.loading) {
          this.loading = true;
          let data = {
            type: '2',
            id: row.id,
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
          xz.AdvanceFun(data, 'CancellApproval').then(res => {
            if (res.status == 'ok') {
              this.getList();
              this.$message.success('作废成功！');
              this.loading = false;
            } else {
              this.getList();
              this.$message.error(res.msg);
              this.loading = false;
            }
          })
        }
      },
      revoke(row) {
        if (!this.loading) {
          this.loading = true;
          let data = {
            type: '2', //1暂支 2日志
            id: row.id,
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
          xz.AdvanceFun(data, 'RevokingApproval').then(res => {
            if (res.status == 'ok') {
              this.getList();
              this.$message.success('撤销成功！');
              this.loading = false;
            } else {
              this.getList();
              this.$message.error(res.msg);
              this.loading = false;
            }
          })
        }
      },
      tableRowClassName({
        row,
        rowIndex
      }) {
        if (this.tabName == '报销单') {
          if (row.processStateStr && row.processStateStr.indexOf('退回') > -1) {
            return 'warning-row';
          }
        }
      },

      confirmbacthPayHand(type) {
        if (this.multipleSelection.length > 0) {
          this.showBatchhandc = true;
          this.payResult = type;
        } else {
          this.$message.error('必须选择一个');

        }
      },


      //批量打款手工
      bacthPayHand(type) {
        if (this.multipleSelection.length > 0) {

          this.TotalFees = 0;
          let arr = [];
          this.multipleSelection.forEach((element, index) => {
            arr.push({
              id: element.id,
              payResult: this.payResult, //1代表成功,0为失败
              writtenAmount: element.writtenAmount, //打款金额
              userId: Cookies.get("userid-b"),
              roleType: localStorage.loginRoletype
            })
            this.TotalFees = math.format(
              math.add(
                math.bignumber(this.TotalFees), math.bignumber(Number(element.writtenAmount))
              )
            )


          });
          xz.AdvanceFun(arr, 'LogVerifPayResult').then(res => {
            try {
              if (res.status == 'ok') {
                this.getList();
                this.$message.success('成功！');
                this.showBatchhandc = false;
                this.loading = false;
              } else {
                this.loading = false;
                this.$message.error(res.msg);
              }
            } catch (e) {
              this.$message.error('系统出错');
              this.loading = false;
            }
          })


        } else {
          this.$message.warning('请至少选择两笔单子')
        }
      },
      //批量打款
      bacthPay() {
        if (this.multipleSelection.length > 1) {
          let companyName = this.multipleSelection[0].companyName;
          let canPay = true;
          this.TotalFees = 0;
          let arr = [];
          this.multipleSelection.forEach((element, index) => {
            arr.push(element.id)
            this.TotalFees = math.format(
              math.add(
                math.bignumber(this.TotalFees), math.bignumber(Number(element.writtenAmount))
              )
            )
            if (element.companyName != companyName) {
              canPay = false
            }
            if (index == this.multipleSelection.length - 1) {
              if (canPay) {
                this.payForm = {
                  id: arr.toString(),
                  BusiType: 2,
                  payAccount: '', //公司的付款账号
                  payAccountName: '', //公司的付款账号
                  payAccountDepositBank: '', //公司的付款账号开户行
                  InternalAccount: '', //内部账号
                  InternalAccountName: '', //内部账号名
                }
                this.showBatchPay = true;
              } else {
                this.$message.warning('请选择打款公司相同的单子')
              }
            }
          });
        } else {
          this.$message.warning('请至少选择两笔单子')
        }
      },
      confirmBatchPay() {
        this.payForm.payAccount = '';
        this.payForm.payAccountName = this.multipleSelection[0].companyName;
        xz.getCompfinanceSet(this.multipleSelection[0].companyName, this.roletype).then(res => {
          if (res.status == 'ok') {
            if (!res.data.BankAccountJ) {
              this.BankAccount = []
            } else {
              res.data.BankAccountJ.forEach(element => {
                if (element.IsDefault != undefined && element.IsDefault == '1') {
                  this.payForm.payAccount = element.Account
                }
              });
              this.BankAccount = res.data.BankAccountJ;
              this.innerVisibleCA = true;
            }
          } else {
            this.BankAccount = [];
          }
        })
      },
      confirmPay() {
        if (!this.payForm.payAccount) {
          this.$message.warning('请选择打款账号')
        } else {
          this.pay();
        }
      },
      pay() {
        this.isBtnLoading = true;
        this.BankAccount.forEach((e, index) => {
          if (e.Account == this.payForm.payAccount) {
            this.payForm.payAccountDepositBank = e.OpeningBank;
            this.payForm.payAccountName = e.AccountName;
          }
          if (index == this.BankAccount.length - 1) {
            xz.cbsPayAdvance(this.payForm, this.roletype).then(res => {
              try {
                if (res.status == 'ok') {
                  this.$message.success('打款成功！');
                  this.isBtnLoading = false;
                  this.innerVisibleCA = false;
                  this.innerVisibleIC = false;
                  this.showBatchPay = false;
                  this.getList();
                } else {
                  this.isBtnLoading = false;
                  this.innerVisibleCA = false;
                  this.innerVisibleIC = false;
                  this.showBatchPay = false;
                  this.getList();
                  this.$message.error(res.msg);
                }
              } catch (e) {
                this.$message.error('系统出错');
                this.isBtnLoading = false;
              }
            })
          }
        });
      },
      innerPay() {
        this.changeIC('宁波英普瑞特供应链管理有限公司');
        this.innerVisibleIC = true;
      },
      confirmICPay() {
        this.payForm.InternalAccount = this.InternalAccount;
        this.payForm.InternalAccountName = this.internalCompany;
        this.pay();
      },
      changeIC(val) {
        console.log(val)
        if (val) {
          xz.getCompfinanceSet(val, this.roletype).then(res => {
            if (res.status == 'ok') {
              if (!res.data.BankAccountJ) {
                this.icBankAccount = []
              } else {
                res.data.BankAccountJ.forEach(element => {
                  if (element.IsDefault != undefined && element.IsDefault == '1') {
                    this.InternalAccount = element.Account
                  }
                });
                this.icBankAccount = res.data.BankAccountJ;
              }
            } else {
              this.icBankAccount = [];
            }
          })
        }
      },
      //批量审批
      bacthApprove() {
        if (this.multipleSelection.length > 0) {
          this.showBatchApprove = true;
        } else {
          this.$message.warning('请至少选择一笔单子')
        }
      },
      confirmBatchApprove(results) {
        let arr = [];
        this.multipleSelection.forEach((element, index) => {
          arr.push(element.id)
          if (index == this.multipleSelection.length - 1) {
            this.isBtnLoading = true;
            let data = {
              type: '4',
              userId: Cookies.get("userid-b"),
              roleType: localStorage.loginRoletype,
              results,
              remark: '',
              busiId: arr.toString()
            }
            xz.VerifiDepartAudit(data).then(res => {
              if (res.status == 'ok') {
                this.$message.success('操作成功！');
                this.isBtnLoading = false;
                this.isSubmit = true;
                // this.goBack();
              } else {
                this.$message.error(res.msg)
                this.isBtnLoading = false;
              }
            })
          }
        });
      },
      exportList() {
        xz.ExportAdvanceList(this.listQuery, 'ExportGetLogVerifPageList').then(res => {
          try {
            var data = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8"
            });
            var downloadUrl = window.URL.createObjectURL(data);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = this.tabName + "列表.xlsx";
            anchor.click();
            window.URL.revokeObjectURL(data);
            this.loading = false;
          } catch (e) {
            this.loading = false;
            this.$message.error('导出异常')
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .expandTable {
    padding-left: 50px;
  }

  .salaryPayingCompanyItem {
    margin-bottom: 30px;
  }

  .salaryPayingCompany {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 15px;
  }

  .salaryPayingCompany_radio {
    padding-left: 30px;
  }

  .noAccountTips {
    font-size: 14px;
    margin-bottom: 15px;
  }

  .payTips {
    color: red;
    font-size: 14px;
    margin-left: 50px;
    line-height: 32px;
  }

  .pro_down_box {
    padding-left: 28px;
  }
</style>
<style>
  .page_logReimbursement .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_logReimbursement .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_logReimbursement .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_logReimbursement .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_logReimbursement .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_logReimbursement .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_logReimbursement .expandTable .el-table__empty-block {
    width: 601px;
    max-width: 601px;
    min-width: 601px;
    padding-right: 0;
  }

  .page_logReimbursement .el-table .warning-row {
    background: oldlace;
  }

  .page_logReimbursement .el-table__expand-icon {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  /*2.展开按钮未点击的样式是加号带边框*/
  .page_logReimbursement .el-table__expand-icon .el-icon-arrow-right:before {
    content: "\e6d9";
    /* border: 1px solid #19bd92;
    padding: 2px; */
    color: #19bd92;
  }

  /*3.展开按钮点击后的样式是减号带边框*/
  .page_logReimbursement .el-table__expand-icon--expanded .el-icon-arrow-right:before {
    content: "\e6d8";
    color: #19bd92;
  }

  .page_logReimbursement .el-table__expand-icon {
    font-size: 22px;
  }

  .page_logReimbursement .el-table__expand-icon>.el-icon {
    position: static;
    margin: 0 auto;
  }
</style>